<template>
<a-modal
    v-bind:open="showModal"
    width="400px"
    :closable="true"
    :footer="null"
    :mask-closable="true"
    :mask-style="{backdropFilter: 'blur(2px)'}"
    :keyboard="false"
    footer
    :destroyOnClose="true"
    @cancel="closeModal"
    centered
    class="scroll-y-none"
>
    <div class="modal-yellow-body" id="qr-login-modal">
        <div class="download-modal-body">
            <div class="download-modal-body">
                <div class="app-download-text">
                    <h3>QR코드로 앱에 로그인</h3>
                    <p v-if="supportTab">지원 접속에서는 QR 로그인을 쓸 수 없습니다.</p>
                    <p v-if="!isSucceeded">
                    <span>서티라이프 모바일 앱</span>의 로그인 화면에서<br> 'QR 코드로 로그인' 메뉴를 선택하고<br> 하단의
                    QR코드를 스캔해 주세요.
                    </p>
                </div>
                <div class="app-download-qr">
                    <a-qrcode
                        v-if="!isSucceeded"
                        id="qr-image"
                        class="qr-image"
                        error-level="H"
                        :value="qrCodeHash"
                        bgColor="white"
                        :icon="certiLogo"
                        :size="160"
                    />
                    <div 
                        v-if="isSucceeded"
                        style="width: 160px; height: 160px; display: flex; align-items: center; justify-content: center;"
                    >
                        <Vue3Lottie 
                            :animation-data="SuccessAnim"
                            :auto-play="true"
                            :loop="false"
                            :speed="1"
                            style="width: 160px; "
                            ref="anim" 
                        />
                    </div>
                    <div class="qr-progress-bar-container" v-if="!isSucceeded">
                        <div class="qr-progress-bar"
                            :style="computedProgressBarWidth"
                        />
                    </div>
                    <div class="qr-text-container" v-if="!isSucceeded">
                        <div class="qr-text count">{{ computedLeftTime }}</div>
                        <div class="qr-text">인증 유효 시간</div>
                    </div>
                    <div class="qr-text-container" v-if="isSucceeded">
                        <div class="qr-text big">인증이 완료되었습니다. <br/>서티라이프 모바일 앱에서 로그인이 되었는지 <br/>확인해 주세요.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-content-body">
        <div class="qr-container">
            <div class="qr-download-container" style="flex-direction: column; justify-content: start; display: flex; align-items: start;">
                <span style="font-weight:700; width: 100%; text-align: center; font-size: 16px; display: flex; justify-content: center;">
                    QR스캔이 안되시나요?
                </span>
                <span>
                    <img src="@/assets/img/app-download-appstore.svg" />
                    <img src="@/assets/img/app-download-playstore.svg" />
                    <div>
                    <span>휴대폰 번호를 입력해 다운로드 링크를 받아보세요.</span>
                    </div>
                </span>
                <div class="phone-num-area ant-like-input" style="padding: 0px;">
                    <input 
                    pattern="[0-9]+"
                    class="phone-num-input" 
                    placeholder="휴대전화 번호 입력"
                    maxlength="13"
                    v-model="phoneNumber"
                    id="app-modal-input"
                    ref="appModalInput"
                    @input="onPhoneNumberChange"
                    >
                    <button 
                    class="phone-num-btn"
                    @click="sendSms"
                    >
                    링크 보내기
                    </button>
                </div>
            </div>
        </div>
    </div>
</a-modal>
</template>
<script setup>
import { getRefreshToken, isSupportTab } from "@/utils/tokenStore";
import { watch, ref, computed, onMounted, } from 'vue';
import { useRoute } from 'vue-router';

import certiLogo from '@/assets/img/certi-logo.png';
import apiInstance from '@/axios.js'
import { RouterEnum } from '@/router/router.enums';
import { BuildModeEnum, } from '@/enums/common.enums';
import {
    oneBtnDialog,
    phoneNumberFormatter,
} from '@/utils/utils';
import { Constants } from '@/utils/constants';
import validators from '@/utils/validators';

import { Vue3Lottie } from 'vue3-lottie';
import SuccessAnim from '@/assets/img/lottie/success.json';
import dayjs from 'dayjs';

const emit = defineEmits(['closeModal']);

const route = useRoute();
const supportTab = isSupportTab();

// 모달 기본 설정 시작

const props = defineProps({
    showModal: {
        type: Boolean,
        required: true,
        default: false
    },
});

onMounted(async () => {
    watch(() => props.showModal, async (newValue, oldValue) => {
        if(newValue === true) {
            await generateQrCode();
            handleSeconds();
        } else {
            closeModal();
        }
    });
});


const phoneNumber = ref('');
const onPhoneNumberChange = (event) => {
    const formattedValue = phoneNumberFormatter(event.target.value);
    phoneNumber.value = formattedValue;
}





let anim = ref(null);

const getSmsLink = () => {
    if(process.env.NODE_ENV === BuildModeEnum.LOCAL) {
        return `http://localhost:2213${RouterEnum.GoToApp.path}`;
    }
    if(process.env.NODE_ENV === BuildModeEnum.STG) {
        return `https://stg-hospital.certi.life${RouterEnum.GoToApp.path}`;
    }
    if(process.env.NODE_ENV === BuildModeEnum.DEV) {
        return `https://intest-hospital.certi.life${RouterEnum.GoToApp.path}`;
    }
    return `https://hospital.certi.life${RouterEnum.GoToApp.path}`;
}

const sendSms = async () => {
    const result = await validators().validatePhoneNumber(phoneNumber.value);
    if(!result) return;

    const text = `${Constants.miscText.appDownloadText}\n${getSmsLink()}`;
    
    const obj = {};
    obj.messageType = `SM`;
    obj.contents = text;
    obj.mobile = phoneNumber.value.replace(/-/g, '');

    try {
        await apiInstance.post(`messages/mobile`, obj);
        await oneBtnDialog('문자 메시지 발송 성공', '앱 다운로드 링크가 입력하신 휴대전화 번호로 발송되었습니다. 문자 메시지를 확인해주세요.', false);
    } catch(error) {
        console.log(error);
        await oneBtnDialog('문자 메시지 발송 실패', '입력하신 휴대전화 번호를 다시 한 번 확인해주세요.', false);
    }
}



const closeModal = () => {
    if(timer) clearInterval(timer);
    if(pollingTimer) clearInterval(pollingTimer);
    isSucceeded.value = false;
    time.value = fullTime.value;
    falseCount.value = 0;
    emit('closeModal', 'qrLoginModal', false);
};

const offset = ref(0);

const getCurrentKoreaTime = () => {
    const currentTime = dayjs().valueOf() + offset.value;
    return currentTime;
}

let timer;
const fullTime = ref(30000);
const time = ref(fullTime.value);
const shouldRegenerateQR = ref(true);
const expireAt = ref(0);
const createAt = ref(0);

const handleSeconds = () => {
    clearInterval(timer);
    if(isSucceeded.value) return;

    if(time.value > 0) {
        shouldRegenerateQR.value = true;
    }
    timer = setInterval(() => {
        if(time.value > 0) {
            time.value = expireAt.value - getCurrentKoreaTime();
        } else {
            if(shouldRegenerateQR.value) {
                handleOnCountZero();
            }
        }
    }, 10);
}




const handleOnCountZero = async () => {
    if (shouldRegenerateQR.value) {
        await generateQrCode();
        time.value = fullTime.value;
    }
    shouldRegenerateQR.value = true;
}


const qrCodeHash = ref('');

const generateQrCode = async () => {
    if(route.path === RouterEnum.Signin.path || !props.showModal) return;

    if(shouldRegenerateQR.value) {
        shouldRegenerateQR.value = false;
    }
    const result = await getAuthCode();
    setPollingTimer();
    if(!result.qrHash) return;
    const serverTime = dayjs(result.createAt).valueOf();
    const clientTime = dayjs().valueOf();
    offset.value = serverTime - clientTime;
    
    const difference = dayjs(result.expireAt).diff(dayjs(result.createAt));
    expireAt.value = dayjs(result.expireAt);
    createAt.value = dayjs(result.createAt);
    setFullTime(difference);
    falseCount.value = 0;
    qrCodeHash.value = `${getGoToAppUrl()}?authCode=${result.qrHash}`;
}

const getGoToAppUrl = () => {
    if(process.env.NODE_ENV === BuildModeEnum.LOCAL) {
        return `http://localhost:2213${RouterEnum.GoToApp.path}`;
    }
    if(process.env.NODE_ENV === BuildModeEnum.STG) {
        return `https://stg-app.certi.life${RouterEnum.GoToApp.path}`;
    }
    if(process.env.NODE_ENV === BuildModeEnum.DEV) {
        return `https://intest-app.certi.life${RouterEnum.GoToApp.path}`;
    }
    return `https://app.certi.life${RouterEnum.GoToApp.path}`;
}


const setFullTime = (difference) => {
    if(!difference) {
        fullTime.value = 0;
        return;
    }
    fullTime.value = difference;
}

// TODO: 해야됨
const getAuthCode = async () => {
    if(route.path === RouterEnum.Signin.path) return {};
    // 지원 탭에서는 QR 로그인을 만들지 않음(서버도 서브 계정의 QR 만들기를 거절, 지원 refresh 토큰을 다른 곳에 보내지 않음 — W6 C3)
    if(isSupportTab()) return {};
    try {
        const response = await apiInstance.post('/auth/generate/qrcode', {
            refreshToken: getRefreshToken()
        });
        if(response.status !== 200 && response.status !== 201) return{};
        return response.data;
    } catch(error) {
        console.log(error);
        oneBtnDialog('QR코드 수신 실패', 'QR코드를 받아오는데 실패했습니다.', false);
        return {};
    }
}

let pollingTimer;

const isSucceeded = ref(false);

const falseCount = ref(0);

const setPollingTimer = () => {
    if(pollingTimer) clearInterval(pollingTimer);
    pollingTimer = setInterval(async () => {
        const result = await checkIfLoginDone();
        if(!result)  falseCount.value ++;
        if(qrCodeHash.value && falseCount.value > 1) {
        clearInterval(pollingTimer);
        clearInterval(timer);
        isSucceeded.value = true;
        setTimeout(() => {
            closeModal();
        }, 3000);
        }
    }, 1000);
}



const checkIfLoginDone = async () => {
    try {
        const qrString = qrCodeHash.value.split('authCode=')[1];
        const response = await apiInstance.post('/auth/polling/qrcode', {qrHash: qrString});
        if(response.status !== 200 && response.status !== 201) return true;
        return response.data;
    } catch(error) {
        console.log(error);
        return true;
    }
}

// 모달 기본 설정 끝

const computedLeftTime = computed(() => {
    const totalSeconds = Math.round(time.value / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
});

const computedProgressBarWidth = computed(() => {
    const widthPercent = (time.value / fullTime.value) * 100;
    return `width: ${widthPercent}% !important;`;
})

</script>
<style scoped lang="scss">
@import '@/assets/scss/qr-login-modal.scss';
</style>
